var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-3"},[_c('VueSlider',{attrs:{"marks":true,"data":_vm.sliderData,"adsorb":true},on:{"change":_vm.changed},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }